import { readViewStandardColumns } from './read'

export const viewStandardColumns = {
  readCollection: readViewStandardColumns,
}
